import { render, staticRenderFns } from "./directionsDetail.vue?vue&type=template&id=ef1d976c&scoped=true&"
import script from "./directionsDetail.vue?vue&type=script&lang=js&"
export * from "./directionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./directionsDetail.vue?vue&type=style&index=0&id=ef1d976c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1d976c",
  null
  
)

export default component.exports